import clsx from 'clsx';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import { POSIcon, POSIconButton } from '../..';
import { ActionMenuProps } from '../../interfaces/TableActionsProps';
import { POSICons } from '../POSIcon/POSIcon';

type TableActionMenuProps<TData> = ActionMenuProps<TData> & {
  item: TData;
};

export const TableActionMenu = <TData,>({
  menuIcon,
  menuHeader,
  menuItems,
  onMenuTrigger,
  circular,
  position,
  item,
}: TableActionMenuProps<TData>) => {
  const renderMenuIcon = () => {
    let icon = 'eclipse' as POSICons;

    if (menuIcon && typeof menuIcon !== 'string') {
      return menuIcon?.(item);
    }

    if (menuIcon && typeof menuIcon === 'string') {
      icon = menuIcon;
    }

    if (circular === true) {
      return (
        <POSIconButton
          icon={icon}
          iconOnly
          inverted
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            return true;
          }}
        />
      );
    } else {
      return <POSIcon icon={icon} className="large" />;
    }
  };

  return (
    <Popup
      content={
        <>
          <div className="p-os-action-menu-header">
            {menuHeader &&
              (typeof menuHeader === 'string' ? menuHeader : menuHeader(item))}
          </div>
          {menuItems
            .filter((action) => !action.isHidden?.(item))
            .map((action) => {
              return (
                <div
                  key={action.name}
                  className={clsx('p-os-action-menu-item', {
                    disabled: !!action.isDisabled?.(item),
                  })}
                  onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    e.stopPropagation();
                    if (!!action.isDisabled?.(item)) return;
                    action.onClick(item);
                  }}
                >
                  {typeof action.icon === 'string' ? (
                    <POSIcon icon={action.icon} className="large" />
                  ) : (
                    action.icon(item)
                  )}
                  {action.name}
                </div>
              );
            })}
        </>
      }
      basic
      className="p-os-action-menu"
      position={position ? position : 'bottom center'}
      hoverable
      on={onMenuTrigger ? onMenuTrigger : 'click'}
      trigger={<div style={{ cursor: 'pointer' }}>{renderMenuIcon()}</div>}
    />
  );
};
